import React, { useEffect, useMemo } from 'react';
import useTranslate from '../useTranslate';
import { usePbDispatch, usePbSelector } from '../../store/pbStoreHooks';
import OperationalContactAssignmentsForm, {
    MansionAssignments,
} from './operational-contact-assignments-form';
import { Col, Row } from 'react-bootstrap';
import EditLargeCardFormik from '../main/edit-large-card-formik';
import {
    ResetPutAllMansionsToOperationalContact,
    SetAllMansionsToOperationalContact,
} from '../../store/operationalContactsSlice';
import { RequestStatus } from '../../store/network/managedRequest';
import { LoadMansions } from '../../store/mansionsSlice';
import { PbRequest } from '../../store/pbRequest';

interface Props {
    contactId: number;
    hasWritePermission: boolean;
}

function OperationalContactAssignmentsCard(props: Readonly<Props>) {
    const strings = useTranslate('OperationalContactAssign');
    const [newInit, setNewInit] = React.useState(false);
    const dispatch = usePbDispatch();
    const mansionsById = usePbSelector((state) => state.mansions.mansionsById);
    const listRequest = usePbSelector(
        (state) => state.pbRequest[PbRequest.GET_OPERATIONAL_CONTACTS]
    );
    const listRequestData = usePbSelector(
        (state) => state.operationalContacts.operationalContacts
    );
    const contactData = useMemo(() => {
        return listRequestData?.list?.find(
            (it) => it.operational_contact_id === props.contactId
        );
    }, [listRequestData?.list, props.contactId]);
    const updateRequest = usePbSelector(
        (state) => state.pbRequest[PbRequest.PUT_ALL_MANSIONS_REQUEST]
    );

    useEffect(() => {
        return () => {
            resetEditError();
        };
    }, [props.contactId]);
    useEffect(() => {
        dispatch(LoadMansions());
    }, []);
    useEffect(() => {
        if (listRequest.status === RequestStatus.PENDING) {
            setNewInit(true);
        } else if (newInit && listRequest.status === RequestStatus.SUCCESS) {
            setNewInit(false);
        }
    }, [newInit, listRequest.status]);

    const initialValues: MansionAssignments = {
        mansionIds: Object.values(contactData?.mansions ?? {}).map(
            (mansion) => mansion.mansion_id
        ),
    };

    return (
        <Row>
            <Col xs={8}>
                <EditLargeCardFormik
                    title={strings.title}
                    handleSubmit={handleSubmit}
                    initialValues={initialValues}
                    error={updateRequest.status === RequestStatus.FAILURE}
                    errorElement={getUpdateErrorMessage()}
                    disabled={!props.hasWritePermission}
                    enableReinitialize={newInit}
                    handleCancel={resetEditError}
                >
                    {(formProps) => (
                        <OperationalContactAssignmentsForm
                            disabled={!formProps.active}
                            idToMansion={mansionsById}
                        />
                    )}
                </EditLargeCardFormik>
            </Col>
        </Row>
    );

    function handleSubmit(values: MansionAssignments) {
        dispatch(
            SetAllMansionsToOperationalContact(
                props.contactId,
                values.mansionIds
            )
        );
    }

    function getUpdateErrorMessage() {
        if (updateRequest.status === RequestStatus.FAILURE) {
            return (
                <div key="UNKNOWN" className="alert alert-danger">
                    {strings.errorAssign}
                </div>
            );
        }
        return null;
    }

    function resetEditError() {
        dispatch(ResetPutAllMansionsToOperationalContact());
    }
}

export default OperationalContactAssignmentsCard;
